// extracted by mini-css-extract-plugin
module.exports = {"block":"CustomClass_block__veYB3","iconWrapper":"CustomClass_iconWrapper__pDgoN","imageTile":"CustomClass_imageTile__HXreh"};